import { cn } from '@/lib/cn'

interface KpiCardProps {
  label: string
  value: number | string
  unit?: string
  alert?: boolean
}

export function KpiCard({ label, value, unit, alert }: KpiCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border bg-white px-4 py-3 shadow-sm',
        alert
          ? 'border-error-300 bg-error-50'
          : 'border-neutral-200',
      )}
    >
      <p className={cn('text-xs font-medium', alert ? 'text-error-600' : 'text-neutral-500')}>
        {label}
      </p>
      <p className={cn('mt-0.5 text-2xl font-bold', alert ? 'text-error-700' : 'text-neutral-900')}>
        {value}
        {unit && (
          <span className={cn('ml-1 text-sm font-medium', alert ? 'text-error-500' : 'text-neutral-400')}>
            {unit}
          </span>
        )}
      </p>
    </div>
  )
}
